<template>
  <div>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-card>
      <div v-if="errormessage">
        <v-alert
          dismissible
          v-model="errormessage"
          dense
          outlined
          type="error"
          >{{ errormessage }}</v-alert
        >
      </div>

      <v-toolbar>
        <v-toolbar-title>{{ name }}</v-toolbar-title>
        <v-spacer></v-spacer>
        Add new
        <v-btn @click="newRep()" class="ma-2" outlined small fab color="indigo">
          <v-icon>mdi-plus</v-icon>
        </v-btn>
        <template v-slot:extension>
          <v-tabs v-model="tab" align-with-title>
            <v-tabs-slider></v-tabs-slider>
            <v-tab v-for="item in tabitems" :key="item.index">
              {{ item.name }}
            </v-tab>
          </v-tabs>
        </template>
      </v-toolbar>
      <v-tabs-items v-model="tab">
        <v-tab-item v-for="item in tabitems" :key="item.index">
          <v-card flat>
            <v-data-table
              v-if="item.index === 0"
              :headers="headers"
              :items="reps"
              item-value="Id_No"
              :search="search"
              :custom-filter="filterOnlyCapsText"
            >
              <template v-slot:top>
                <v-text-field
                  v-model="search"
                  label="Search"
                  class="mx-4"
                ></v-text-field>
              </template>
              <template v-slot:item="{ item }">
                <tr :class="checkDel(item)">
                  <td>{{ item.RepCode }}</td>
                  <td>{{ item.RepName.toUpperCase() }}</td>
                  <td>{{ item.Address.toUpperCase() }}</td>
                  <td>{{ item.Mobile }}</td>
                  <td>{{ item.Creditlimit }}</td>
                  <td v-html="formaticon(item.Disabled)"></td>
                  <td v-html="formaticon(item.delete)"></td>

                  <td>
                    <v-btn
                      color="primary"
                      @click.stop="getRepDetails(item.RepCode)"
                    >
                      Manage
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card>
        </v-tab-item>
      </v-tabs-items>

      <v-dialog v-model="dialog" max-width="900px">
        <v-card>
          <v-card-title>{{ dialogtitle }}</v-card-title>
          <v-card-text>
            <v-alert
              dismissible
              v-if="dialogerror"
              dense
              outlined
              type="error"
              >{{ dialogerror }}</v-alert
            >

            <v-form
              ref="form"
              @submit.stop.prevent="checkForm"
              class="text-center"
              method="post"
            >
              <v-text-field
                v-model="selectedrep.RepName"
                label="Rep Name"
                :rules="[rules.required]"
                class="mx-4"
              ></v-text-field>
              <v-text-field
                v-model="selectedrep.Address1"
                label="Address line 1"
                class="mx-4"
              ></v-text-field>
              <v-text-field
                v-model="selectedrep.Address2"
                label="Address line 2"
                class="mx-4"
              ></v-text-field>
              <v-text-field
                v-model="selectedrep.Address3"
                label="Address line 3"
                class="mx-4"
              ></v-text-field>
              <v-text-field
                v-model="selectedrep.Mobile"
                label="Mobile"
                type="number"
                :rules="[rules.required]"
                class="mx-4"
              ></v-text-field>
              <v-text-field
                v-model="selectedrep.Creditlimit"
                label="Credit limit"
                type="number"
                class="mx-4"
              ></v-text-field>
              <v-text-field
                v-model="selectedrep.targetsale"
                label="Target Sale"
                type="number"
                class="mx-4"
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="dialog = false">
              Close
            </v-btn>
            <v-btn color="green darken-1" text @click="saveRep()"> Save </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </div>
</template>

<script>
/*
Address: ",,"
Creditlimit: 0
Disabled: false
Mobile: "0716814133"
RepCode: "S001"
RepName: "MR. PASAN KANCHUKA"
delete: false
userid: null
*/
import { HTTP, setAuthToken, BASE_URL } from "../../../lib/http.common";
export default {
  data() {
    return {
      overlay: true,
      dialog: false,
      dialogtitle: "Edit Rep",
      dialogerror: null,
      search: "",
      name: "REPS",
      tabitems: [{ name: "All Reps", index: 0 }],
      rules: {
        required: (value) => !!value || "Required.",
      },
      tab: null,
      errormessage: null,
      reps: [],
      selectedrep: {},
      headers: [
        {
          value: "RepCode",
          text: "Code",
          sortable: true,
        },
        {
          value: "RepName",
          text: "Name",
          sortable: true,
        },
        {
          value: "Address",
          text: "Address",
          sortable: true,
        },
        {
          value: "Mobile",
          text: "Mobile",
          sortable: true,
        },
        {
          value: "Creditlimit",
          text: "Credit limit",
          sortable: true,
        },
        {
          value: "Disabled",
          text: "Disabled",
          sortable: true,
        },
        {
          value: "delete",
          text: "Delete",
          sortable: true,
        },
        { value: "actions", text: "Actions" },
      ],
    };
  },
  methods: {
    checkDel(item) {
      if (!item.Disabled || !item.delete) {
        return "deleted";
      } else return "";
    },
    filterOnlyCapsText(value, search) {
      return (
        value != null &&
        search != null &&
        typeof value === "string" &&
        value
          .toString()
          .toLocaleLowerCase()
          .indexOf(search.toLocaleLowerCase()) !== -1
      );
    },
    newRep() {
      //this.dialogtitle = "Add Rep";
      //this.dialog = true;
    },
    isLetterOrNumber(e) {
      let char = String.fromCharCode(e.keyCode);
      if (/^[A-Za-z0-9]+$/.test(char)) return true;
      else e.preventDefault();
    },

    checkForm() {
      return this.$refs.form.validate();
    },
    saveRep() {
      if (!this.checkForm()) {
        this.dialogerror = "Check enterd informations!!";
        return;
      }
      this.dialogerror = null;
      HTTP.post(BASE_URL + "reps", this.selectedrep)
        .then((response) => {
          this.error = response.data[0].success;
          if (!response.data[0].success) {
            if (!response.data[0].season) this.$router.push("/login");

            this.dialogerror = response.data[0].message;
          } else {
            this.dialogerror = null;
            this.dialog = false;
            this.getreps();
          }
        })
        .catch((e) => {
          this.dialogerror = e;
        });
      this.overlay = false;
    },

    getreps() {
      HTTP.get(BASE_URL + "reps")
        .then((response) => {
          this.error = response.data[0].success;
          if (!response.data[0].success) {
            if (!response.data[0].season) this.$router.push("/login");
            this.errormessage = response.data[0].message;
          } else {
            this.errormessage = null;
            this.reps = response.data[0].dataset;
          }
        })
        .catch((e) => {
          this.errormessage = e;
        });
      this.overlay = false;
    },
    getRepDetails(repcode) {
      this.dialogtitle = "Edit Rep";

      HTTP.get(BASE_URL + `reps/` + repcode)
        .then((response) => {
          this.error = response.data[0].success;
          if (!response.data[0].success) {
            if (!response.data[0].season) this.$router.push("/login");
            this.errormessage = response.data[0].message;
          } else {
            this.errormessage = null;
            this.selectedrep = response.data[0].dataset[0];
          }
          this.dialog = true;
        })
        .catch((e) => {
          this.errormessage = e;
        });
    },

    formaticon(v) {
      if (v) {
        return '<i class="mdi mdi-check green--text"></i>';
      } else {
        return '<i class="mdi mdi-window-close red--text"></i>';
      }
    },
  },
  computed: {
    RepFullName: function () {
      if (this.selectedrep.RepName)
        return this.selectedrep.RepName.toUpperCase();
      return "";
    },
  },
  mounted() {
    this.getreps();
  },
  beforeCreate() {
    console.clear();
    setAuthToken();
  },
};
</script>

<style scoped>
.v-application .mb-6 {
  margin-bottom: 0px !important;
}
</style>